import React from 'react';
import { Navigate } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import { useCRMStore } from '../store/crmStore';
import { usePermissionStore } from '../store/permissionStore';
import { hasRouteAccess, type SystemRouteKey } from './permissions';

interface SystemRouteGuardProps {
  routeKey: SystemRouteKey;
  children: React.ReactNode;
}

export const SystemRouteGuard: React.FC<SystemRouteGuardProps> = ({ routeKey, children }) => {
  const token = localStorage.getItem('token');
  const currentUser = useCRMStore((s) => s.currentUser);
  const { role, permissions, loaded } = usePermissionStore(
    useShallow((s) => ({
      role: s.role,
      permissions: s.permissions,
      loaded: s.loaded,
    })),
  );

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!loaded) {
    return null;
  }

  // 优先用 permissionStore.role（与侧栏菜单同源），回退到 crmStore.currentUser.role，
  // 保证「能否进 /hr」与「能否看到人事管理菜单」判定一致。
  const effectiveRole = (role || currentUser?.role) as typeof currentUser.role | undefined;
  if (!hasRouteAccess(effectiveRole, permissions, routeKey)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

